/* SLV INDIA — reliable product image autoplay for Dawn media-gallery.
   Uses the actual gallery track, not hidden theme arrow controls. */
(() => {
  const SELECTOR = 'media-gallery';
  const INTERVAL = 4500;

  function setup(gallery) {
    if (gallery.dataset.slvAutoplayBound === 'true') return;
    const viewer = gallery.querySelector('slider-component[id^="GalleryViewer-"]');
    const track = viewer?.querySelector('.product__media-list');
    if (!viewer || !track) return;

    const slides = Array.from(track.querySelectorAll('.product__media-item'));
    if (slides.length < 2) return;

    gallery.dataset.slvAutoplayBound = 'true';
    let pausedUntil = 0;
    let current = 0;
    let programmaticScroll = false;
    let settleTimer;

    const updateActive = (index) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === current);
        slide.setAttribute('aria-hidden', i === current ? 'false' : 'true');
      });
    };

    const goTo = (index) => {
      const nextIndex = (index + slides.length) % slides.length;
      const slide = slides[nextIndex];
      if (!slide) return;
      updateActive(nextIndex);
      programmaticScroll = true;
      track.scrollTo({
        left: slide.offsetLeft - track.offsetLeft,
        behavior: 'smooth'
      });
      window.setTimeout(() => { programmaticScroll = false; }, 700);
    };

    const detectManualScroll = () => {
      if (programmaticScroll) return;
      window.clearTimeout(settleTimer);
      settleTimer = window.setTimeout(() => {
        const left = track.scrollLeft;
        let nearest = 0;
        let distance = Infinity;
        slides.forEach((slide, i) => {
          const d = Math.abs((slide.offsetLeft - track.offsetLeft) - left);
          if (d < distance) { distance = d; nearest = i; }
        });
        updateActive(nearest);
        pausedUntil = Date.now() + 3000;
      }, 100);
    };

    track.addEventListener('scroll', detectManualScroll, { passive: true });
    gallery.addEventListener('pointerdown', () => { pausedUntil = Date.now() + 3000; }, { passive: true });
    gallery.addEventListener('focusin', () => { pausedUntil = Date.now() + 3000; });

    updateActive(0);
    track.scrollTo({ left: 0, behavior: 'auto' });

    window.setInterval(() => {
      if (!gallery.isConnected || document.hidden || Date.now() < pausedUntil) return;
      const active = slides[current];
      if (active?.querySelector('video, iframe, model-viewer')) return;
      goTo(current + 1);
    }, INTERVAL);
  }

  function boot() {
    document.querySelectorAll(SELECTOR).forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
  const observer = new MutationObserver(boot);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
